import { usePathname } from "next/navigation"

/**
 * The chain the leaderboard page is for, from its URL ("ALL" on the home page
 * and brand pages resolve to a slug). Unlike the chain filter state — which
 * the root layout seeds as "ALL" on the server and the client syncs after
 * hydration — the path is the same on both, so markup built from it hydrates
 * cleanly. Client-side chain switches push a new path, so it follows them.
 */
export function useLeaderboardChain(): string {
  const segment = usePathname().split("/").filter(Boolean)[0]
  return segment ? segment.toUpperCase() : "ALL"
}
